import styled from 'styled-components';
import {Status, StatusCode} from '../status/status-order';
import {Color} from '../../tokens/colors';
import {ServicesTable} from '../services-table/services-table';

const StyledContainer = styled.div`
    display: ${(props) => (props.isActive ? 'block' : 'none')};
    background-color: ${Color.WHITE};

    @media (max-width: 767px) {
        padding: 24px 0 8px;
    }
`;

const StyledHeader = styled.div`
    display: block;
    padding: 15px 24px 0 52px;

    @media (max-width: 767px) {
        position: relative;
        padding: 0 15px 18px;
        border-bottom: 1px solid ${Color.BLOCK_GRAY};
    }
`;

const StyledInfoList = styled.ul`
    &&& {
        display: flex;
        flex-wrap: wrap;
        gap: 16px 40px;
        margin: 0;
        padding: 0;
        list-style: none;

        &:not(:first-child) {
            padding-top: 15px;
        }

        @media (max-width: 767px) {
            flex-direction: column;
            gap: 14px;
        }
    }
`;

const StyledInfoItem = styled.li`
    &&& {
        margin: 0;
        padding: 0;
        font-weight: 500;
        line-height: 1.2;
        color: ${Color.BLACK};

        &::before {
            content: none;
        }
    }
`;

const StyledInfoMobileStatus = styled.li`
    display: none;
    align-items: center;
    justify-content: space-between;
    background-color: #f6f6f6;

    @media (max-width: 767px) {
        display: flex;
    }

    &&& {
        margin: 0;
        padding: 5px 15px 5px 15px;
        font-weight: 500;
        line-height: 1.2;
        color: ${Color.BLACK};

        &::before {
            content: none;
        }
    }
`;

const StyledStatusTitle = styled.div`
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    color: ${Color.BLACK};
`;

const StyledInfoTitle = styled.p`
    margin: 0 0 6px;
    font-size: 12px;
    color: ${Color.TEXT_GRAY};
`;

const StyledInfoValue = styled.p`
    margin: 0;
    font-size: 13px;
`;

const StyledStatusContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 20px 0;
    padding: 10px 24px 10px 52px;
    background-color: #f6f6f6;

    @media (max-width: 767px) {
        display: none;
    }
`;

const TaskItem = ({isActive, task, userNames}) => {
    return (
        <StyledContainer isActive={isActive}>
            <StyledHeader>
                <StyledInfoList>
                    <StyledInfoItem>
                        <StyledInfoTitle>Дата заказа</StyledInfoTitle>
                        <StyledInfoValue>{task.date}</StyledInfoValue>
                    </StyledInfoItem>
                    <StyledInfoItem>
                        <StyledInfoTitle>ФИО</StyledInfoTitle>
                        <StyledInfoValue>{userNames}</StyledInfoValue>
                    </StyledInfoItem>
                    <StyledInfoItem>
                        <StyledInfoTitle>{task.material.type}</StyledInfoTitle>
                        <StyledInfoValue>{task.material.name}</StyledInfoValue>
                    </StyledInfoItem>
                </StyledInfoList>
                <StyledInfoList>
                    <StyledInfoItem>
                        <StyledInfoTitle>Период готовности</StyledInfoTitle>
                        <StyledInfoValue>
                            {task.dateCompletion.start} - {task.dateCompletion.end}
                        </StyledInfoValue>
                    </StyledInfoItem>
                </StyledInfoList>
            </StyledHeader>

            <StyledInfoMobileStatus>
                <StyledStatusTitle>Статус заказа</StyledStatusTitle>
                <Status code={StatusCode[task.status.code]} isUppercase={true}>
                    {task.status.text}
                </Status>
            </StyledInfoMobileStatus>

            <StyledStatusContainer>
                <StyledStatusTitle>Статус заказа</StyledStatusTitle>
            </StyledStatusContainer>

            <ServicesTable
                hidden={task.services.length <= 0}
                services={task.services}
                taskStatusCode={task.status.code}
                taskStatusText={task.status.text}
            />
        </StyledContainer>
    );
};

export {TaskItem};
